import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { FleetPage } from '../../../../shared/sso-workspace/fleet-page'
import { ExportTab } from './export-tab'
import { LookupTab } from './lookup-tab'
import { VerifyTab } from './verify-tab'
import '../../org/api-keys/api-keys.scss'

export const TABS = [
  { key: 'lookup', label: 'Look up', Component: LookupTab },
  { key: 'verify', label: 'Verify', Component: VerifyTab },
  { key: 'export', label: 'Export', Component: ExportTab }
]

// The website's consent log for EducationXR staff: every cookie choice a
// visitor made on the public website. Look up a consent ID's history, verify
// the ID and signature from a visitor's cookie, or export a date range as
// CSV. The tab is in ?tab=. Records are never changed here.
export const ConsentLogPage = () => {
  const { search } = useLocation()
  const asked = new URLSearchParams(search).get('tab')
  const tab = TABS.find(t => t.key === asked) || TABS[0]
  return (
    <FleetPage title="Consent log"
      purpose="Every cookie choice made on the public website, kept for a year. Look one up by its consent ID, check a visitor's signed ID, or export a date range."
      testId="consent-log-page">
      <nav className="sw-tabs" aria-label="Consent log">
        {TABS.map(t =>
          <NavLink key={t.key} to={`/admin/consent-log?tab=${t.key}`} isActive={() => t.key === tab.key} activeClassName="active"
            aria-current={t.key === tab.key ? 'page' : undefined}>{t.label}</NavLink>)}
      </nav>
      <tab.Component />
    </FleetPage>
  )
}
